module.exports = __webpack_public_path__ + "resource/img/image017.50d3d9b7.png";